import { Instance, types } from 'mobx-state-tree';

export const TimelineGroup = types.model({
  id: types.string,
  title: types.string,
  type: types.string,
  tip: types.maybeNull(types.string),
});

export type TimelineGroupModelType = Instance<typeof TimelineGroup>;
